<style lang="stylus">
        .home-container
            display flex
            position absolute
            left 0
            right 0
            top 0
            bottom 0
            background-color: #fff;
            // ::-webkit-scrollbar
            //     display none
            .home-right-con
                display flex
                flex 1 1 auto
                flex-direction column
                // background-color: #f1f3fb;
                height 100%
                width calc(100% - 200px)
                &.home-right-con-pc
                    background-color var(--backgroudColor)
                    width 100%
                .filenum-tips-pc
                    margin-bottom 16px
                .filter-box
                    // 工作台通用过滤器样式
                    position absolute
                    right 40px
                    top -46px
                    display flex
                    z-index 1
                    &.filter-box-pc
                        top 12px
                    @media screen and (max-width: 1200px)
                        display none
                    .search-box
                        position relative
                        width 240px
                        display flex
                        justify-content space-between
                        align-items center
                        input
                            display inline-block;
                            width 100%;
                            height 28px;
                            line-height 1.5;
                            padding 4px 7px;
                            padding-left 0
                            font-size 12px;
                            text-indent 8px
                            border 1px solid transparent
                            border-radius 6px;
                            color #000;
                            background-color #fff;
                            background-image none;
                            position relative;
                            cursor text;
                            outline none
                            color #9e9e9e
                            &:hover
                                border-color #017fff
                            &:focus
                                border-color #017fff
                                box-shadow: 0px 0px 0px 2px rgba(1, 127, 255, 0.1)
                            &:focus
                                border-color var(--themeColor)
                                box-shadow unset
                        .search-icon
                            position absolute
                            right 4px
                            outline none
                            border none
                            background-color #fff
                            width 24px
                            height 24px
                            display flex
                            justify-content center
                            align-items center
                            border-radius 2px
                            cursor pointer
                            >svg
                                width 24px
                                height 24px
                            &:hover
                                background-color #eeeeee
                            &:active
                                background-color #e0e0e0
                    .button-box
                        display flex
                        align-items center
                        outline none
                        border none
                        pointer-events auto
                        user-select none
                        margin-left 14px
                        font-size 12px
                        border-radius 6px
                        line-height 28px
                        padding 0
                        height 28px
                        cursor pointer
                        background-color initial
                        transition color 0.2s linear, background-color 0.2s linear, border 0.2s linear, box-shadow 0.2s linear, -webkit-box-shadow 0.2s linear
                        >svg
                            fill #424242
                            stroke #424242
                            width 28px
                            height 28px
                        &:hover
                            background-color: rgba(0, 0, 0, 4%);
                        &:active
                            background-color: rgba(0, 0, 0, 6%);
                    .order-box
                        display flex
                        align-items center
                        user-select: none;
                        margin-left 16px
                        padding 4px
                        font-size: 12px;
                        border-radius: 6px;
                        border none
                        line-height 20px
                        background #fff
                        height 28px;
                        cursor pointer
                        transition: color .2s linear,background-color .2s linear,border .2s linear,box-shadow .2s linear,-webkit-box-shadow .2s linear;
                        &:hover
                            color: #82a2fc;
                            background-color: #fff;
                            border-color: #82a2fc;
                        > div
                            position relative
                            border-right 1px solid #dcdee2
                            height 100%
                        svg
                            width 16px
                            height 16px
                            transition all 0.3s
                            margin 0px 2px 0 6px
                            fill #424242
                            stroke #424242
                        a
                            color #000
                            padding 0 20px
                .dark-theme__workbench
                    background #1e1e20
                    .list-header
                        background #343437
                        border-color #343437
                        color #fff
                    .list-header >div:hover
                        background #222
                        border-color #222
                    .files-item-list
                        color #fff
                        .file-name
                            .list-viewonly
                                border-color #c4c4c4
                                p
                                    color #c4c4c4
                    .files-item-list:hover,.folder-item:hover
                        background linear-gradient(90deg, rgba(255, 255, 255, 0.06) 0%, rgba(255, 255, 255, 0) 100%);
                    .folder-item-active,.list-item-active
                        background linear-gradient(90deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
                    .filter-box
                        .search-box
                            input
                                background rgba(255, 255, 255, 0.1);
                                box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.1);
                                color #fff
                                &:hover
                                    border: 1px solid #017FFF;
                                    box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.1);
                                &:focus
                                    border: 1px solid #017FFF;
                                    box-shadow: 0px 0px 0px 2px rgba(1, 127, 255, 0.3);
                            button
                                background #333
                                &:hover
                                    background #222
                                svg
                                    fill #fff
                                    stroke #fff
                        .order-box
                            background #333
                            border none
                            >div
                                border-color #151515
                            svg
                                fill #fff
                                stroke #fff
                            &:hover
                                    background #222
                            a
                                color #fff !important
                            .ivu-select-dropdown
                                background #333
                                .ivu-dropdown-item
                                    color #fff
                                    &:hover
                                        background #222
                        .button-box
                            svg
                                fill #fff
                                stroke #fff
                            &:hover
                                    background #222
                    .wb-header
                        .files-path
                            color #fff
                        .back
                            background #343437
                            color #fff
                            border 1px solid rgba(0,0,0,0.1)
                    .files-scroll
                        .files-folders
                            .folder-item
                                background #333
                        .files-folders,.files-folders-list
                            .folder-text
                                color #fff
                            svg
                                stroke #fff
                                fill #fff
                        &::-webkit-scrollbar-thumb
                            background #484849
                        &::-webkit-scrollbar-track
                            background #1e1e20
                    .emptyCloud
                        // color #fff
                        span
                            color #fff
                        .emptyCloud-viptip
                            color #fff

                    .files-new
                        .files-new-btn.importbtn
                            background #343437
                            color #fff
                            svg
                                fill #fff
                                stroke #fff
                    .tag-list
                        background: #3F3F41;
                        border: 0.5px solid rgba(255, 255, 255, 0.1);
                        box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.03), 0px 22.3363px 17.869px rgba(0, 0, 0, 0.0178832), 0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0121168)
                        li
                            &:hover
                                background rgba(255, 255, 255, 0.08)
                            p
                                color #fff

                .wb-historyView.dark-theme__workbench
                    .files-hv-splice
                        span
                            color #fff
                            background #1e1e20
                        .hv-line
                            background #1e1e20

        .loading
            position absolute
            left 0
            right 0
            top 0
            bottom 0
            display flex
            justify-content center
            align-items center
            z-index 10
            pointer-events none
            user-select none
            img
                width 64px
            &.isTeamsApp
                @media screen and (max-width: 500px)
                    left 50%
                    margin-left -150px
    .viewfade-enter-active,
    .viewfade-leave-active
        transition opacity .1s
    .viewfade-enter,
    .viewfade-leave-to
        opacity 0

    .viewfade-enter.dark-theme__workbench,
    .viewfade-leave-to.dark-theme__workbench
        opacity .9
</style>

<template>
    <div class="home-base">
        <div class="loading" v-if="showLoading" :class="{ isTeamsApp: isTeamsApp }">
            <!-- <Spin></Spin> -->
            <img :src="require('@/home/assets/img/loading-mask.gif')" alt="" />
        </div>

        <ShareBox v-if="shareState" />
        <div class="home-container">
            <Slider v-if="showLeft && isPC"></Slider>
            <SliderOnline v-else-if="showLeft" ref="SliderOnline" />
            <div class="home-right-con" :class="{ 'home-right-con-pc': isPC }" @click="clear">
                <Topbar v-if="!isPC"></Topbar>
                <!-- 用户信息列表 -->
                <UserNotifyMsg ref="UserNotifyMsg" />
                <transition name="viewfade" mode="out-in">
                    <router-view />
                </transition>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import Topbar from "./Topbar.vue";
    import Slider from "./Slider.vue";
    import ShareBox from "./ShareBox.vue";
    import UserNotifyMsg from "./UserNotifyMsg.vue";
    import SliderOnline from "./onlineView/slider-online.vue";
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Topbar,
            Slider,
            ShareBox,
            UserNotifyMsg,
            SliderOnline,
        },
    })
    export default class Base extends Vue {
        get shareState() {
            return this.$store.state.shareState;
        }
        get showLoading() {
            return this.$store.state.showLoading;
        }
        showLeft = true;

        clear() {
            let dom = <any>this.$refs.SliderOnline;
            dom && dom.clear();
        }
        @Watch("isPCDarkMode")
        handleIsPCDarkModeChange(newV) {
            this.initTheme(newV || 0);
        }
        initTheme(index: number) {
            document.body.style.setProperty("--backgroudColor", ["#fff", "#222427", "#222427"][index]);
            document.body.style.setProperty("--backgroudTinyColor", ["#fff", "#FFFFFF1A", "#FFFFFF1A"][index]);
            document.body.style.setProperty("--backgroudDeepColor", ["#fff", "#333333", "#333333"][index]);
            document.body.style.setProperty("--backgroudTextColor", ["#fafafa", "#FFFFFF1A", "#FFFFFF1A"][index]);
            document.body.style.setProperty("--backgroudInputColor", ["#F2F4F9", "#F2F4F91A", "#F2F4F91A"][index]);
            document.body.style.setProperty("--backgroudTemplateColor", ["#F2F4F9", "#FFFFFF14", "#FFFFFF14"][index]);
            document.body.style.setProperty("--backgroudTabColor", ["#F2F4F9", "#FFFFFF14", "#FFFFFF14"][index]);
            document.body.style.setProperty("--backgroudTopBtnColor", ["#017fff0d", "#017fff29", "#017fff29"][index]);
            document.body.style.setProperty("--backgroudTooltipColor", ["#F2F4F9", "#000", "#000"][index]);
            document.body.style.setProperty("--backgroudTemplateImgColor", ["#FFFFFF", "#222427", "#222427"][index]);
            document.body.style.setProperty("--backgroudHomeSliderColor", ["#FFFFFF", "#626365", "#626365"][index]);
            document.body.style.setProperty("--fontTitleColor", ["#000", "#fff", "#fff"][index]);
            document.body.style.setProperty("--fontColor", ["#232323", "#fff", "#fff"][index]);
            document.body.style.setProperty("--fontTinyColor", ["#787878", "#FFFFFFA6", "#FFFFFFA6"][index]);
            document.body.style.setProperty("--fontDeepColor", ["#444444", "#FFFFFFA6", "#FFFFFFA6"][index]);
            document.body.style.setProperty("--fontTabColor", ["#333333", "#ffffff", "#ffffff"][index]);
            document.body.style.setProperty("--fontSearchColor", ["#222222", "#E6E6E6", "#E6E6E6"][index]);
            document.body.style.setProperty("--fontSearchTinyColor", ["#22222266", "#FFFFFF66", "#FFFFFF66"][index]);
            document.body.style.setProperty("--fontTabColor", ["#000000", "#E6E6E6", "#E6E6E6"][index]);
            document.body.style.setProperty("--breadBgColor", ["#3B55950D", "#FFFFFF14", "#FFFFFF14"][index]);
            document.body.style.setProperty("--fontNetworkColor", ["#222222", "#E6E6E6", "#E6E6E6"][index]);
            document.body.style.setProperty("--fontHomeSliderColor", ["#222222", "#E6E6E6", "#E6E6E6"][index]);
            document.body.style.setProperty("--fontTemplateTitleColor", ["#333333", "#E6E6E6", "#E6E6E6"][index]);
            document.body.style.setProperty("--fontTemplateDescTitleColor", ["#303030", "#E6E6E6", "#E6E6E6"][index]);
            document.body.style.setProperty("--fontNetworkTinyColor", ["#22222266", "#FFFFFF66", "#FFFFFF66"][index]);
            document.body.style.setProperty("--borderColor", ["#f0f0f0", "#78787880", "#78787880"][index]);
            document.body.style.setProperty("--borderColorE2", ["#e2e2e2", "#78787880", "#78787880"][index]);
            document.body.style.setProperty("--borderTemplateColor", ["#00000014", "#FFFFFF1F", "#FFFFFF1F"][index]);
            document.body.style.setProperty("--scrollBackground", ["#e0e0e0", "#FFFFFF33", "#FFFFFF33"][index]);
            document.body.style.setProperty("--iconTemplateColor", ["#8e8e8e", "#E6E6E6", "#E6E6E6"][index]);
        }

        //生命周期
        mounted() {
            this.initTheme(this.isPCDarkMode || 0);
            window.postMessage(
                {
                    type: "homeMounted",
                },
                "*"
            );
        }

        created() {
            this.showLeft = !new URLSearchParams(location.search.substr(1)).get("left");
            // this.haveLeft = haveLeft;
            // let EDCurrentStr = Cookie.getItem('EDCurrent')
            // let EDCurrent = JSON.parse(EDCurrentStr)
            // this.$store.commit('setState', {type: 'userInfo', data: EDCurrent})
            // if (EDCurrent) {
            //     this.$store.dispatch('getUserInfo')
            // }
        }
    }
</script>
